import { useEffect, useState } from 'react';

/**
 * Herinneringen voor sport/programma's, per browser (localStorage).
 * Een melding verschijnt in de app zelf; via https ook als systeemmelding als je dat toestaat.
 */

export interface Reminder {
  id: string;
  title: string;
  subtitle?: string;
  start: number;
  accountId: string;
  streamId: number;
}

const KEY = 'tumedia.reminders';
const listeners = new Set<() => void>();

function read(): Reminder[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as Reminder[];
  } catch {
    return [];
  }
}

function write(list: Reminder[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // opslag geblokkeerd: dan alleen in deze sessie
  }
  memory = list;
  listeners.forEach((l) => l());
}

let memory = read();

export function reminders(): Reminder[] {
  return memory;
}

export function hasReminder(id: string): boolean {
  return memory.some((r) => r.id === id);
}

export function toggleReminder(r: Reminder): boolean {
  if (hasReminder(r.id)) {
    write(memory.filter((x) => x.id !== r.id));
    return false;
  }
  write([...memory.filter((x) => x.start > Date.now() - 3600_000), r]);
  if ('Notification' in window && window.isSecureContext && Notification.permission === 'default') {
    void Notification.requestPermission().catch(() => undefined);
  }
  return true;
}

export function removeReminder(id: string): void {
  write(memory.filter((x) => x.id !== id));
}

export function useReminders(): Reminder[] {
  const [, setTick] = useState(0);
  useEffect(() => {
    const l = () => setTick((n) => n + 1);
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return memory;
}
